/**
 * Underline text inside a text object. Used to signal words with spelling errors
 * @param textZone the text object containing text to underline
 * @param underlineStart text start position (of string) for underlining
 * @param underlineEnd text end position (of string) for underlining
 */
export const underlineText = (textZone, underlineStart, underlineEnd) => {
  textZone.setSelectionStyles({ textBackgroundColor: '#FFDDDC' }, underlineStart, underlineEnd);
};
